import { Text } from '@noorden-insurtech/alba-design-system';
import { memo } from 'react';
import type { CapitalGlobalSelectOption } from '@/features/quotes/schemas/capital-global/coverages-catalog';
import { CapitalGlobalClearableSelect } from './capital-global-clearable-select.component';

/* eslint-disable no-unused-vars -- callback parameter names document arity for callers */
type Props = {
  value: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  items?: CapitalGlobalSelectOption[];
};
/* eslint-enable no-unused-vars */

/**
 * Isolated + memo: Ark Select is sensitive to parent re-renders from other sections (unstable tree).
 */
export const CapitalizationSelectSection = memo(
  function CapitalizationSelectSection({
    value,
    onValueChange,
    disabled,
    required = false,
    error,
    items = [],
  }: Props) {
    return (
      <div className='flex w-full max-w-[605px] flex-col gap-6'>
        <Text className='text-lg font-bold text-alba-black-500'>
          Capitalização
        </Text>
        <CapitalGlobalClearableSelect
          label='Informe uma capitalização'
          value={value}
          onValueChange={onValueChange}
          placeholder='Selecione a capitalização'
          disabled={disabled}
          required={required}
          error={error}
          items={items}
        />
      </div>
    );
  }
);
